import type { MailboxInfo } from 'owa-client-types';
import { isAccountFeatureEnabled } from 'owa-feature-flags';

/**
 * Checks if the Bizchat SSR feature is enabled for the given mailbox. This requires both the
 * 'mon-copilot-bizchat-ocdi' feature and at least one of the SSR features ('mon-copilot-bizchat-ssr' or
 * 'mon-copilot-bizchat-fullscreen-ssr') to be enabled.
 * @param mailboxInfo - The mailbox information to check the feature flags against.
 * @returns True if the Bizchat SSR feature is enabled for the mailbox, false otherwise.
 */
export const isBizchatSSRFeatureEnabledForMailbox = (mailboxInfo: MailboxInfo): boolean => {
    return (
        isAccountFeatureEnabled('mon-copilot-bizchat-ocdi', mailboxInfo) &&
        (isAccountFeatureEnabled('mon-copilot-bizchat-ssr', mailboxInfo) ||
            isAccountFeatureEnabled('mon-copilot-bizchat-fullscreen-ssr', mailboxInfo))
    );
};
